const en = {
  // Brand display names live in `src/branding/useBrand.ts` — not here.
  // Proper nouns don't translate, and keeping them in a single source of
  // truth avoids the per-language drift we used to have.
  nav: {
    songs: 'Songs',
    artists: 'Artists',
    search: 'Search',
    generator: 'Generator',
    signIn: 'Sign in',
    signUp: 'Sign up',
    signOut: 'Sign out',
  },
  home: {
    heroTitle: 'Discover the stories behind your favorite song lyrics',
    heroSubtitle: 'We analyze the meaning behind your favorite song lyrics',
    searchPlaceholder: 'Search any song or meaning…',
    trendingLabel: 'TRENDING',
    latestLabel: 'LATEST',
    allArtists: 'All artists',
  },
  search: {
    title: 'Search results',
    empty: 'No songs found.',
    placeholder: 'Search any song or meaning…',
  },
  songCard: {
    by: 'by',
  },
  footer: {
    updates: 'Updates',
    about: 'About',
    contact: 'Contact',
    help: 'Help center ↗',
    terms: 'Terms & Conditions',
    privacy: 'Privacy & Cookies',
    copyright: '© {{years}}',
    language: 'Language',
  },
  languages: {
    en: 'English',
    es: 'Spanish',
    pt: 'Portuguese',
  },
  songDetail: {
    pageSubtitle: 'Lyrics, meaning, and song reference for creating an original MixGenie track.',
    moreByArtist: 'More by {{artist}}',
    meaningHeading: 'Meaning',
    lyricsHeading: 'Lyrics',
    lyricsOriginalTab: 'Original',
    lyricsAlreadyIn: 'These lyrics are already in {{language}}.',
    noTranslationYet: 'No {{language}} translation yet.',
    noMeaningYet: 'No {{language}} meaning yet.',
    getNow: 'Get now',
    translatingTo: 'Translating to {{language}}…',
    generatingMeaning: 'Generating {{language}} meaning…',
    noLyricsForMeaning: 'No lyrics found, so we couldn’t generate a meaning.',
    noLyricsFound: 'No lyrics found for this song.',
    translationUnavailable: 'Translation unavailable without lyrics.',
    songNotFound: 'Song not found',
    loadingSong: 'Loading song…',
    fetchingLyrics: 'Fetching lyrics…',
    generatingMeaningShort: 'Generating meaning…',
    findingCoverArt: 'Finding cover art…',
    almostReady: 'Almost ready…',
  },
  createSimilar: {
    heading: 'Create a song similar to this one',
    description: 'Sign up for a free MixGenie subscription with {{credits}} credits and generate an original song inspired by {{title}} by {{artist}}.',
    descriptionAuthed: 'Generate an original song inspired by {{title}} by {{artist}}.',
    cta: 'Start with this reference',
    ctaAuthed: 'Start with this reference',
  },
  streamingLinks: {
    heading: 'Listen on',
  },
};

export default en;
export type Resources = typeof en;
